<ng-container *ngIf="context() as reviewContext">
  <button *ngIf="collapsed()" type="button" class="health-review-launcher" aria-label="Open event health assistant" (click)="toggleCollapsed()">
    <mat-icon>health_and_safety</mat-icon>
    <span>{{ session.remainingCount() }}</span>
  </button>

  <aside *ngIf="!collapsed()" class="health-review-assistant" cdkDrag [cdkDragConstrainPosition]="constrainDrag" aria-label="Event health assistant">
    <header class="assistant-header">
      <div class="assistant-header__identity" cdkDragHandle title="Drag to move">
        <span class="assistant-logo"><mat-icon>health_and_safety</mat-icon></span>
        <div>
          <span class="assistant-kicker">Fix event health</span>
          <h2>{{ reviewContext.eventType }}</h2>
        </div>
      </div>
      <button type="button" class="icon-button" aria-label="Collapse health assistant" (click)="toggleCollapsed()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </header>

    <section class="assistant-progress" *ngIf="findings().length || !assessmentNotice()">
      <div>
        <span>{{ session.completedCount() }} updated · pending save</span>
        <strong>{{ progress() }}%</strong>
      </div>
      <div class="assistant-progress__track"><span [style.width.%]="progress()"></span></div>
    </section>

    <section class="assistant-findings">
      <p *ngIf="session.navigationNotice()" class="text-secondary px-4 text-sm" role="status">{{ session.navigationNotice() }}</p>
      <p *ngIf="assessmentNotice()" class="rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-100" role="status">
        {{ assessmentNotice() }}
      </p>
      <div class="assistant-findings__heading">
        <span>Findings to review</span>
        <span>{{ session.remainingCount() }}</span>
      </div>
      <p *ngIf="session.warningCount()" class="text-secondary px-4 text-xs">
        {{ session.blockingCount() }} blocking errors · {{ session.warningCount() }} warnings
      </p>

      <div *ngIf="!findings().length && !assessmentNotice()" class="assistant-all-clear">
        <mat-icon>{{ reviewContext.status === 'ready' ? 'check_circle' : 'info' }}</mat-icon>
        <div>
          <strong>No health findings</strong>
          <small>{{ reviewContext.status === 'ready' ? 'This event passed the GDST 1.2 assessment.' : 'No individual findings were returned for this assessment.' }}</small>
        </div>
      </div>

      <article
        *ngFor="let finding of findings(); let index = index"
        role="button"
        tabindex="0"
        class="assistant-finding"
        [class.assistant-finding--active]="session.activeFindingId() === finding.id"
        [class.assistant-finding--changed]="session.isLocallyChanged(finding.id) || session.isResolved(finding.id)"
        (click)="selectFinding(finding)"
        (keydown.enter)="selectFinding(finding)"
        (keydown.space)="selectFinding(finding); $event.preventDefault()"
      >
        <span class="finding-icon" [ngClass]="session.isResolved(finding.id) ? 'text-emerald-600' : 'finding-icon--' + finding.severity">
          <mat-icon *ngIf="session.isResolved(finding.id); else findingNumber">check_circle</mat-icon>
          <ng-template #findingNumber><span [attr.aria-label]="'Finding ' + (index + 1)">{{ index + 1 }}</span></ng-template>
        </span>
        <span class="finding-body">
          <span class="finding-heading">
            <strong>{{ finding.title }}</strong>
            <span class="finding-severity" [ngClass]="'finding-severity--' + finding.severity" [attr.aria-label]="'Severity: ' + finding.severity">
              {{ finding.severity | titlecase }}
            </span>
          </span>
          <small>{{ finding.help || finding.message }}</small>

          <span *ngIf="finding.suggestions.length && !session.isLocallyChanged(finding.id)" class="finding-suggestions">
            <span *ngFor="let item of finding.suggestions" class="suggestion-card" [ngClass]="'suggestion-card--' + finding.severity">
              <span>
                <small>Suggested from {{ item.source }}</small>
                <strong>{{ item.label }}</strong>
                <small>{{ item.reason }}</small>
              </span>
              <button type="button" (click)="applySuggestion(finding, item, $event)">Apply</button>
            </span>
          </span>

          <button *ngIf="session.isLocallyChanged(finding.id)" type="button" class="restore-original" (click)="restoreOriginalValue(finding, $event)">
            <mat-icon>undo</mat-icon>
            Restore original
          </button>
          <span *ngIf="!session.isResolved(finding.id)" class="text-secondary mt-2 text-xs leading-relaxed">
            {{ finding.target.label }}
          </span>
        </span>
        <!-- Technical details temporarily hidden. Keep the drawer for later restoration.
        <details class="assistant-details" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <summary [attr.aria-label]="'Technical details for ' + finding.title">
            <mat-icon aria-hidden="true">info_outline</mat-icon>
            <span>Technical details</span>
            <mat-icon class="assistant-details__chevron" aria-hidden="true">expand_more</mat-icon>
          </summary>
          <div class="assistant-details__content">
            <div class="assistant-details__explanation">
              <strong>Explanation</strong>
              <p>{{ errorExplanation(finding) }}</p>
            </div>
            <dl>
              <dt>Rule code</dt>
              <dd>{{ finding.ruleId }}</dd>
              <dt>Scope</dt>
              <dd>{{ scopeLabel(finding.scope) }}</dd>
              <ng-container *ngIf="finding.target.path">
                <dt>Data path</dt>
                <dd>{{ finding.target.path }}</dd>
              </ng-container>
              <ng-container *ngIf="finding.reference">
                <dt>Linked record</dt>
                <dd>{{ finding.reference }}</dd>
              </ng-container>
            </dl>
          </div>
        </details>
        -->
      </article>
    </section>

    <footer class="assistant-footer">
      <div class="finding-navigation">
        <button type="button" aria-label="Previous finding" (click)="previousFinding()"><mat-icon>arrow_upward</mat-icon></button>
        <button type="button" aria-label="Next finding" (click)="nextFinding()"><mat-icon>arrow_downward</mat-icon></button>
      </div>
      <button type="button" class="exit-review" (click)="goToSubmit()">
        <mat-icon>south</mat-icon>
        Go to Submit
      </button>
    </footer>
  </aside>
</ng-container>
